/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-08-11 09:52:02
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-08-18 10:53:32
 * @FilePath: \ui\src\api\question.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import http from './index.ts'
export const getQuestion = (): Promise<Object> => {
  return http.get('/base/hot/prompts')
}
